import { inject, Injectable, signal } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { map } from "rxjs/operators";
import { filter } from "rxjs";

@Injectable()
export class AppLayoutService{
  isSidebarOpened = signal(false);
  currentRouteName = signal('');
  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);

  constructor(){
   this.addCurrentRouteNameTracker();
   this.openSidebarIfRequireOnInit();
  }

  // Inicializáláskor, ha gépen vagyunk akkor alapból legyen nyitva
  openSidebarIfRequireOnInit(){
    if(window.innerWidth > 768){
      this.isSidebarOpened.set(true);
    }
  }

  addCurrentRouteNameTracker(){
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map((event: NavigationEnd) => {
        let route = this.activatedRoute;
        while(route.firstChild){
          route = route.firstChild;
        }
        return route;
      })
    ).subscribe(route => {
      this.currentRouteName.set(route.snapshot.data['name'] || '');
    });
  }

  toggleSidebar(){
    this.isSidebarOpened.update(value => !value);
  }

  sidebarNavigateTo(url: string){
    if(window.innerWidth < 768){
      this.toggleSidebar();
    }
    this.router.navigate([url]);
  }
}